export default __webpack_public_path__ + "static/media/unknown.0cf84f2f.svg";